import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { sendTeaserEvent } from './legacy';
import { sendTeaserWebEvent } from './modern';
export function sendPostViewAnalytics(payload, action) {
  var _config$get;
  var config = getConfig();
  var logger = getLogger();
  var source = (_config$get = config.get('builders.postViewAnalyticsSource')) !== null && _config$get !== void 0 ? _config$get : 'both';
  switch (source) {
    case 'both':
      sendTeaserEvent(payload, action);
      sendTeaserWebEvent(payload, action);
      break;
    case 'teaser':
      sendTeaserEvent(payload, action);
      break;
    case 'teaser-web':
      sendTeaserWebEvent(payload, action);
      break;
    default:
      {
        var message = "Unknown post view analytics source - ".concat(source);
        logger.error(message);
        throw new Error(message);
      }
  }
}